angular.module('acme.view.application.resources.modals.assign', [
    'ui.router',
    'ui.bootstrap',
    'acme.view.application.resources.modals.assign.controllers',
    'acme.common.directive.hoverTooltip',
    'acme.common.directive.dataGrid'
])

    .config(function config($stateProvider) {

        // Create both abstract view and template view.
        // Abstract Views are enabled by default
        var resourcesModalsAssign = {
            name: 'application.resources.modals.assign',
            url: '/resources/modals/assign',
            views: {
                "main": {
                    controller: 'ResourcesModalsAssignController',
                    // Assumes the view is entirely self contained
                    templateUrl: 'views/application/views/resources/modals/assign/assign.tpl.html'
                }
            },
            data: {
                pageTitle: '   ',
                enablePreferences: true,
                /** Secure With Permissions **/
                permissions: []
            }
        };

        $stateProvider
            .state(resourcesModalsAssign);
    });
